/** Civil date helpers for the audit filters (person's timezone; never `new Date('YYYY-MM-DD')`). */
import { addCivilDays } from '@/shared/servedWindow';

const CIVIL = /^\d{4}-\d{2}-\d{2}$/;

export function isCivilDate(value: string): boolean {
  return CIVIL.test(value);
}

/**
 * Today's civil date in `timeZone`. A machine value (the API filter), never shown: `en-CA` is used
 * only because it yields ISO `YYYY-MM-DD`.
 */
export function civilToday(timeZone: string, now = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timeZone.length > 0 ? timeZone : 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const year = parts.find((part) => part.type === 'year')?.value ?? '1970';
  const month = parts.find((part) => part.type === 'month')?.value ?? '01';
  const day = parts.find((part) => part.type === 'day')?.value ?? '01';
  return `${year}-${month}-${day}`;
}

/** Last 30 civil days ending today in `timeZone` (inclusive). */
export function defaultAuditRange(
  timeZone: string,
  now = new Date(),
): { from: string; to: string } {
  const to = civilToday(timeZone, now);
  return { from: addCivilDays(to, -29), to };
}

export function validRange(from: string, to: string): boolean {
  return isCivilDate(from) && isCivilDate(to) && from <= to;
}
